<template>
    <div class="text-center">
        <a  
            :href="`tel:${phone}`"
            class="">
            <button class="bg-green-400 text-base text-gray-900 uppercase shadow-md rounded-md py-2 px-4 md:py-4 md:px-4 3xl:text-lg hover:shadow-lg focus:outline-none">
                <span class="block font-semibold">Call for Availability</span>
                <span class="text-sm font-medium flex">
                    <span class="my-auto">
                        <svg 
                            xmlns="http://www.w3.org/2000/svg" 
                            class="h-5 w-5" 
                            fill="none" 
                            viewBox="0 0 24 24" 
                            stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                        </svg>
                    </span>
                    <span class="my-auto pl-1">
                        {{formattedPhone}}
                    </span>
                    
                </span>
            </button>
        </a>
        <!-- <p>
           
        </p> -->
        <!-- <p class="py-4 relative top-2">
            - OR -
        </p>
        <p class="py-4 text-sm">
            Interested in speaking with one of our other therapists?
        </p>
        <a 
            :href="otherTherapist.url" 
            target="_blank"
            class="bg-gray-50 border text-sm text-black font-medium shadow-md rounded-md py-3 px-3 hover:shadow-lg focus:outline-none">
            Book a Consultation With <span class="font-semibold">{{otherTherapist.name}}</span>
        </a> -->
    </div>
</template>

<script>
export default {
    name: 'CallToAction',
    props: {
        phone: {
            type: String,
            required: true
        },
        formattedPhone: {
            type: String,
            required: true
        },
        otherTherapist: {
            type: Object,
            required: true
        }
    }
}
</script>

<style scoped>

</style>